import {Model} from "@vuex-orm/core";
import Article from "@models/helpers/Article";
import Accessorygroup from "@models/helpers/Accessorygroup";
import Countryprice from "@models/helpers/Countryprice";

import {executeRules, resetRules} from "@services/helpers/ruleHandler";

export default class StoredArticle extends Model {
  static entity = "storedArticles";

  static primaryKey = ["article_id", "unit_id", "accessorygroup_id"];

  static fields() {
    return {
      article_id: this.attr(null),
      unit_id: this.attr(null),
      accessorygroup_id: this.attr(null),

      quantity: this.number(null),
      positionDescription: this.attr(null),
      isUpdated: this.boolean(false),

      article: this.belongsTo(Article, "article_id"),
      accessorygroup: this.belongsTo(Accessorygroup, "accessorygroup_id"),

      status: this.string("default"),
      position: this.number(0).nullable(),
    };
  }

  getStoreId() {
    return this.unit_id;
  }

  static beforeCreate(article) {
    if (
      article.quantity > 0 &&
      (article.accessorygroup_id != 1 || article.updateDevice) &&
      article.isUpdated == true
    ) {
      article.quantity = executeRules(article, "unit");
      article.isUpdated = false;
    }
  }

  static beforeUpdate(article) {
    if (
      article.quantity > 0 &&
      (article.accessorygroup_id != 1 || article.updateDevice) &&
      article.isUpdated == true
    ) {
      article.quantity = executeRules(article, "unit");
      article.isUpdated = false;
    }
    if (
      article.quantity == 0 &&
      article.accessorygroup_id != 1 &&
      article.isUpdated == true
    ) {
      article.quantity = resetRules(article, "unit");
      article.isUpdated = false;
    }
  }

  getLatestPrice() {
    const prices = Countryprice.query()
      .where("article_id", this.article_id)
      .get();

    return prices
      .filter(p => p.valid_from)
      .sort((a, b) => {
        const dateA = new Date(String(a.valid_from.date || a.valid_from).replace(" ", "T"));
        const dateB = new Date(String(b.valid_from.date || b.valid_from).replace(" ", "T"));

        return dateB - dateA;
      })[0];
  }

  getPrice() {
    // const prices = Countryprice.query()
    //   .where("article_id", this.article_id)
    //   .get();
    //
    // const price = prices
    //   .filter(p => p.valid_from)
    //   .sort((a, b) => new Date(b.valid_from) - new Date(a.valid_from))[0];
    //
    // if (!price || price.unit_price == null) return "-";
    //
    // return Number(price.unit_price).toFixed(2);
    const price = this.getLatestPrice();

    if (!price || price.unit_price == null) return "-";

    return Number(price.unit_price).toFixed(2);
  }

  getTotalPrice() {
    // const price = Countryprice.query()
    //   .where("article_id", this.article_id)
    //   .first();
    // if (!price || !price.unit_price) return "-";
    // return Number(price.unit_price) * this.quantity;
    const price = this.getLatestPrice();

    if (!price || price.unit_price == null) return "-";

    return (Number(price.unit_price) * this.quantity).toFixed(2);
  }
}
